<template>
  <el-form ref="formRef" :model="formState" :rules="rules">
    <el-row :gutter="16">
      <el-col :span="12">
        <el-form-item label="借款人还款账号" prop="returnLoanAccount">
          <RxkSelect
            v-model="formState.returnLoanAccount"
            placeholder="请选择"
            filterable
            allow-create
            style="width: 100%"
            :disabled="getDisabled(permissions, 'returnLoanAccount')"
            :list="bankList"
            @change="changeAccount($event, 0)"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="借款人收款账号" prop="loanPayeeAccount">
          <RxkSelect
            v-model="formState.loanPayeeAccount"
            placeholder="请选择"
            style="width: 100%"
            filterable
            allow-create
            default-first-option
            :disabled="getDisabled(permissions, 'loanPayeeAccount')"
            :list="bankList"
            @change="changeAccount($event, 1)"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="借款人还款账户开户银行" prop="returnLoanBank">
          <RxkInput
            v-model="formState.returnLoanBank"
            :formatter="textFormatter"
            maxlength="10"
            placeholder="请输入"
            :disabled="getDisabled(permissions, 'returnLoanBank')"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="借款人收款开户银行" prop="loanUserBank">
          <RxkInput
            v-model="formState.loanUserBank"
            :formatter="textFormatter"
            maxlength="10"
            :disabled="getDisabled(permissions, 'loanUserBank')"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="借款人还款账户名" prop="returnLoanName">
          <RxkInput
            v-model="formState.returnLoanName"
            placeholder="请输入"
            :formatter="textFormatter"
            maxlength="10"
            :disabled="getDisabled(permissions, 'returnLoanName')"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="借款人收款账户名" prop="loanAccountName">
          <RxkInput
            v-model="formState.loanAccountName"
            maxlength="10"
            :formatter="textFormatter"
            :disabled="getDisabled(permissions, 'loanAccountName')"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script lang="ts" setup>
import { RxkSelect, RxkInput } from '@/components/common'
import { bankListget } from '@/apis/erp/loanManagement'
import { List } from '@/types/common'
import { uniqBy } from 'lodash-es'

interface FormState {
  [x: string]: any
  loanAccountName: string //	借款人账户名		false
  loanPayeeAccount: string //	借款人收款账号		false
  loanUserBank: string //	借款人开户银行		false
  returnLoanAccount: string //	借款人还款账号		false
  returnLoanBank: string //	借款人还款账户开户银行		false
  returnLoanName: string //	借款人还款账户名
}

const props = defineProps({
  formValue: {
    type: Object as PropType<FormState>,
    default: () => ({})
  },
  permissions: {
    type: Object,
    default: () => ({})
  }
})

const formRef = ref()

const bankList = ref<List[]>([])

const formState = reactive<FormState>({
  loanAccountName: '',
  loanPayeeAccount: '',
  loanUserBank: '',
  returnLoanAccount: '',
  returnLoanBank: '',
  returnLoanName: ''
})

const defaultRules: Recordable = {
  loanAccountName: [{ required: true, message: '请选择借款人账户名', trigger: 'blur' }],
  loanPayeeAccount: [{ required: true, message: '请选择借款人收款账号', trigger: 'blur' }],
  loanUserBank: [{ required: true, message: '请选择借款人开户银行', trigger: 'blur' }],
  returnLoanAccount: [{ required: true, message: '请选择借款人还款账号', trigger: 'blur' }],
  returnLoanBank: [{ required: true, message: '请选择借款人还款账户开户银行', trigger: 'blur' }],
  returnLoanName: [{ required: true, message: '请选择借款人还款账户名', trigger: 'blur' }]
}

const rules = computed(() => {
  let rules: Recordable = []
  for (let key in formState) {
    let temp = props?.permissions?.[formState[key]]
    if (temp instanceof Array && temp.includes('REQUIRED')) {
      rules[key] = defaultRules[key]
    }
  }
  return rules
})

function getDisabled(permissions: Recordable, key: string) {
  let temp = permissions?.[key]
  if (temp instanceof Array) {
    return !temp.includes('WRITE')
  }
  return true
}

async function queryBankList() {
  try {
    const res =
      (await bankListget({
        userId: props.formValue.borrowerId,
        productId: props.formValue.productId,
        customerPhone: props.formValue.borrowerPhone
      })) || []
    bankList.value = res.map((el: Recordable) => {
      return {
        ...el,
        value: el.returnCardNumber,
        label: `${el.returnCardNumber}(${el.status === 1 ? '已绑卡' : '未绑卡'})`
      }
    })
    bankList.value.push({
      label: props.formValue.returnLoanAccount,
      value: props.formValue.returnLoanAccount,
      returnCardNumber: props.formValue.returnLoanAccount,
      returnCardOpenBank: props.formValue.returnLoanBank,
      returnCardAccountName: props.formValue.returnLoanName
    })
    bankList.value.push({
      label: props.formValue.loanPayeeAccount,
      value: props.formValue.loanPayeeAccount,
      returnCardNumber: props.formValue.loanPayeeAccount,
      returnCardOpenBank: props.formValue.loanUserBank,
      returnCardAccountName: props.formValue.loanAccountName
    })
    bankList.value = uniqBy(unref(bankList), 'value')
  } catch (e) {
    console.log(e)
  }
}

function changeAccount(e: string, type: number) {
  let item = bankList.value.find((item: Recordable) => item.returnCardNumber === e)
  console.log(e, type)
  if (type === 1) {
    if (!/^\d+$/.test(formState.loanPayeeAccount) || formState.loanPayeeAccount.length > 19) {
      ElMessage.error('只能输入小于等于19位的数字！')
      formState.loanPayeeAccount = ''
    }
    formState.loanUserBank = item?.returnCardOpenBank
    formState.loanAccountName = item?.returnCardAccountName
  } else {
    if (!/^\d+$/.test(formState.returnLoanAccount) || formState.returnLoanAccount.length > 19) {
      ElMessage.error('只能输入小于等于19位的数字！')
      formState.returnLoanAccount = ''
    }
    formState.returnLoanBank = item?.returnCardOpenBank
    formState.returnLoanName = item?.returnCardAccountName
  }
}

onMounted(() => {
  for (let key in formState) {
    formState[key] = props.formValue[key]
  }
  queryBankList()
})

function textFormatter(val: string) {
  return val.replace(/[^\u4e00-\u9fa5]/g, '')
}

async function sure() {
  let valid = false
  try {
    valid = await formRef.value.validate()
  } catch (e) {
    console.log(e)
  }
  if (valid) {
    return { ...formState }
  }
  return false
}

defineExpose({
  sure
})
</script>
